import React, { useState } from 'react';
import Swal from 'sweetalert2';
import './contact.css';
import linkedin from '../../assets/linkedin.png';
// 
const Contact = () => {
    const [result, setResult] = useState('');

    const onSubmit = async (event) => {
        event.preventDefault();
        setResult("Sending...");
        const formData = new FormData(event.target);

        formData.append("access_key", "40f3666d-147b-44f6-9652-382d4abf0cf5");

        const response = await fetch("https://api.web3forms.com/submit", {
            method: "POST",
            body: formData
        });

        const data = await response.json();

        if (data.success) {
            event.target.reset();
            Swal.fire({
                title: "Thank you",
                text: "Form successfully sent.",
                icon: "success"
            });
            setResult('');
        } else {
            setResult("There was an error. Please try again later.");
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!"
            });
        }
    };

    return (
        <section className='contact' id='contact'>
            <div className='container mt-5'>
                <div className='text-center mb-3'>
                    <h1 className='introText'>Contact<span> Me</span></h1>
                </div>
                <div className='col-lg-12 d-flex justify-content-between align-items-center flex-wrap gap-2'>
                    <div className='col-lg-5 mb-3' data-aos="fade-up">
                        <h5>Get in <span className="introText">Touch</span></h5>
                        <p>
                            Feel free to reach out for project discussions or inquiries. 
                            Email me with any questions—I’ll be happy to answer.
                        </p>
                        <div className='mt-3'>
                            <h5>Email</h5>
                            <a href='mailto:amulrajs@yahoo.com'>
                                <p style={{color: '#8a8a8a'}}>amulrajs@yahoo.com</p>
                            </a>
                        </div>
                        <div className='mt-3'>
                            <h5>Mobile Number</h5>
                            <a href='tel:+917667602027'>
                                <p style={{color: '#8a8a8a'}}>+91 7667602027</p>
                            </a>
                        </div>
                        <a href='https://www.linkedin.com/in/amul-raj-s' target='_blank' rel="noreferrer" aria-label="LinkedIn Profile">
                            <img src={linkedin} alt='LinkedIn' className='linkedin' width="30" />
                        </a>
                    </div>
                    <div className='col-lg-5 contact-bar' data-aos="fade-up">
                        <h5 className='mb-3'>Message me</h5>
                        <form onSubmit={onSubmit}>
                            <div className='input-box mt-4'>
                                {/* <label htmlFor='name' className='sr-only'>Your Name</label> */}
                                <input type='text' className='field' placeholder='Your Name' name='name' id='name' required />
                            </div>
                            <div className='input-box mt-3'>
                                {/* <label htmlFor='number' className='sr-only'>Your Number</label> */}
                                <input type='number' className='field' placeholder='Your Number' name='number' id='number' required />
                            </div>
                            <div className='input-box mt-3'>
                                {/* <label htmlFor='email' className='sr-only'>Your Email</label> */}
                                <input type='email' className='field' placeholder='Your Email' name='email' id='email' required />
                            </div>
                            <div className='input-box mt-3'>
                                {/* <label htmlFor='message' className='sr-only'>Message</label> */}
                                <textarea name='message' className='field mess' placeholder='Message...' id='message' required></textarea>
                            </div>
                            <button type='submit'>Send Message</button>
                            {result && <p className="form-result">{result}</p>}
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Contact;
